

var _squid = require('squid');

require('./directive');

require('./addcard/route');

require('./selectcard/route');

require('./addbilling/route');

require('./addCep/route');

require('../confirm-upop/route');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddCardFlowRoute', function () {

    return _squid.$ComponentRoute.extend('CardRoute', {

        name: 'addCardFlow',
        directive: 'xo-add-card-flow',
        titleContent: 'asideHeader.addCard',
        children: [{
            name: '$AddCardRoute',
            attributes: {
                token: 'token',
                cardmodel: 'cardmodel',
                done: 'addCCDone',
                messagetitle: 'messagetitle',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                isupdatecard: 'isupdatecard',
                'parent-callbacks': 'callbacks',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion',
                'page-level': 'pageLevel',
                logout: 'logout',
                phone: 'phone',
                'show-balance-flow': 'showBalanceFlow',
                'show-cancel': 'showCancel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'on-success': 'onSuccess',
                'back-uri': 'backUri',
                'show-incentive': 'showIncentive',
                'incentive-amount': 'incentiveAmount',
                'update-card-cpa': 'updateCardCpa',
                cause: 'cause'
            }

        }, {
            name: '$SelectCardRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                message: 'message',
                pagetitle: 'pagetitle',
                sidebar: 'sidebar',
                'selected-promotion-card-type': 'selectedPromotionCardType',
                promotion: 'promotion'
            }
        }, {
            name: '$AddBillingRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                showmeftsection: 'showmeftsection',
                'parent-callbacks': 'callbacks',
                hideparenthead: 'hideparenthead',
                billingaddressupdated: 'billingaddressupdated',
                'prefill-address': 'prefillAddress'
            }
        }, {
            name: '$AddCepRoute',
            attributes: {
                token: 'token',
                sidebar: 'sidebar',
                'done-fn': 'cepDone',
                'prefill-address': 'prefillAddress'
            }
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/route.js
// module chunks = 0